<template>
  <div  >
<!--   <div class="pull-to-refresh" @touchstart="touchStart" @touchmove="touchMove" @touchend="touchEnd">
        <div class="content" >

        </div>

      </div> -->

    <div class="headbt pull-to-refresh"  >
      测评任务:进行中
    </div>


      <div class="rwgl" v-if="all_count== 0 && isShow == true">
        <img src="../../assets/img/zwsj.jpg"/>
      </div>
        <div class="rwgl" v-for="item in listData" >
          <div class="uinfo">
          	<div class="uinfo_1 ">

          	<ul class="list-group">

              <li class="list-group-item  userliebiao">

              	<div class=" col-sm-4 col-4 col-md-4 leftsj" >
              		任务名称
              	</div>
              	<div class=" col-sm-8 col-8 col-md-8 rwmc rightsj jxz"  style="white-space: nowrap;overflow: hidden;text-overflow: ellipsis;" >
              		{{item.taskName}}
              	</div>
              </li>
              <li class="list-group-item  userliebiao">
              	<div class=" col-sm-3 col-3 col-md-3 leftsj" >
                   开始时间
                 </div>
                <div class=" col-sm-9 col-9 col-md-9 rightsj" >
                   {{item.startTime}}
                 </div>
              </li>
          	<li class="list-group-item  userliebiao">
          		<div class=" col-sm-3 col-3 col-md-3 leftsj" >
          	     结束时间
          	   </div>
          	  <div class=" col-sm-9 col-9 col-md-9 rightsj" >
              {{item.endTime}}
          	   </div>
          	</li>
            <li class="list-group-item  userliebiao">
            	<div class=" col-sm-3 col-3 col-md-3 leftsj" >
                 任务状态
               </div>
              <div class=" col-sm-9 col-9 col-md-9 rightsj jxz" >
                {{item.taskStatus}}
               </div>
            </li>
            <li class="list-group-item  userliebiao">
            	<div class=" col-sm-3 col-3 col-md-3 leftsj" >
                 测评状态
               </div>
              <div class=" col-sm-9 col-9 col-md-9 rightsj " v-if="item.evaluationStatus =='已测'" >
                {{item.evaluationStatus}}
               </div>
               <div class=" col-sm-9 col-9 col-md-9 rightsj " v-else-if="item.evaluationStatus =='未测'" >
                 {{item.evaluationStatus}}
                </div>
                <div class=" col-sm-9 col-9 col-md-9 rightsj " v-else >
                  {{item.evaluationStatus}}
                 </div>
            </li>

          	<li class="list-group-item  rwlast"
             @click="rwxq(item)">
          		<div class="qrbc">查看详情</div>
          	</li>

          	</ul>
          	</div>
          </div>
        </div>


       <div class="fixed-right" @click="tz('/user/kefu')">
         <img src="../../assets/img/zxzx.png" >
         <br>
         在线咨询
       </div>
       <div class="jbk" style="height: 140px;">

       </div>
        <div class="footer">
      	  <div class="item_list_menu col-sm-3 col-3 col-md-3" >
      		  <div class="dibumenu">
              	 <img src="../../assets/img/home_xz.png" >
      		</div>
      		  <div class="xmtitle xmtitle_active">
      		  	首页
      		  </div>
      	  </div>
      		<div class="item_list_menu col-sm-3 col-3 col-md-3" @click="tz('/user/cprw')">
      			<div class="dibumenu">
              	<!-- <img src="../../static/wd.png" > -->
                 <img src="../../assets/img/cp.png" >
      			</div>
      			<div class="xmtitle ">
      				测评任务
      			</div>
      		</div>
      		<div class="item_list_menu col-sm-3 col-3 col-md-3" @click="tz('/user/wdcp')">
      			<div class="dibumenu">
      			 	 <img src="../../assets/img/wdcp.png" >
      			</div>
      			<div class="xmtitle ">
      				我的测评
      			</div>
      		</div>
      		<div class="item_list_menu col-sm-3 col-3 col-md-3" @click="tz('/user/index')">
      			<div class="dibumenu">
      				 <img src="../../assets/img/wd.png" >
      			</div>
      			<div class="xmtitle ">
      				我的
      			</div>
      		</div>
      	</div>
   <!-- <div class=" top1 headcd">
    <div class="col-sm-4 col-4 col-md-4" :class="show_num==1?'shouye_active':''" @click="show_num=1">
    		进行中
    </div>
    <div class="col-sm-4 col-4 col-md-4"  :class="show_num==2?'shouye_active':''" @click="show_num=2">
    		已结束
    </div>
    <div class="col-sm-4 col-4 col-md-4"  :class="show_num==3?'shouye_active':''" @click="show_num=3">
    		全部
    </div>
  </div> -->

  </div>
</template>

<script>
import {getrw,mmts} from '../../api/baseset'
import '@/assets/css/index.css';
import '@/assets/bootstrap/5.1.1/bootstrap.min.css';
import '@/assets/bootstrap/5.1.1/bootstrap.bundle.min.js';
  export default {
      data() {
        return {
          show_num:1,
          listData:[],
          all_count:0,
          isShow:false,
          startY: 0,
          isRefreshing: false,
          xiala:0
        }
      },
      mounted() {
      this.getdata(0);

     // this.getsjtjs();
      },
      methods: {

        getdata(status){

         this.loading = true
         this.getdatashuju();
         return ;
         if(status == 1){
            console.log('刷新数据')
          // alert('刷新数据');
              this.getdatashuju();
         }else {
            if(sessionStorage.getItem('user_rwjxz')){
                const user_rw_data = JSON.parse(sessionStorage.getItem('user_rwjxz'))
                console.log('读取缓存数据')
               // alert('读取缓存数据');
                this.listData =user_rw_data
                this.all_count = user_rw_data.length;
            }else{
               console.log('没有缓存')
             // alert('没有缓存');
               this.getdatashuju();

            }
         }




        },
        getdatashuju(){
            getrw()
             .then(res => {
             // console.log(res)
               this.loading = false
                if(res.code == 200){
                 // sessionStorage.setItem()
                  this.listData = res.data
                  this.all_count = res.data.length;

                  sessionStorage.setItem('user_rwjxz', JSON.stringify( this.listData))

                }else{
                  if (res.code == 401 || res.code == 403) {

                  }else if(res.code == 0 || res.code == -1 ||  res.code !=200){

                    this.$message({
                      type: 'info',
                      message: res.msg
                    })
                  } else {
                     //console.log(res)

                  }

                }
                 this.isShow = true
                 this.xiala = 0;
             })
             .catch(err => {
               this.loading = false
               this.$message.error('数据加载失败，请稍后再试！')
             })

        },
         touchStart(e) {
             // this.startY = e.touches[0].clientY;
              this.startY = 0;
            },
            touchMove(e) {
              // 当向下拉时触发
              const currentY = e.touches[0].clientY;
              console.log('currentY:'+currentY)
              if (currentY > this.startY && this.$el.scrollTop === 0 && this.xiala == 0) {
                e.preventDefault();
                const distance = currentY - this.startY;
                if (distance > 100) { // 设置一个阈值，当拉动超过这个距离时开始刷新
                  this.isRefreshing = true;
                  this.$emit('refresh'); // 触发外部的刷新事件
                  this.xiala = 1;
                  this.getdata(1)
                }
              }
            },
            touchEnd() {
              this.startY = 0;
              this.isRefreshing = false;
            },
        // 重置搜索

        rwxq(row){

          localStorage.setItem('rw_data', JSON.stringify({
            title: row.taskName,
            //rwzt:"已结束",
             rwzt:row.taskStatus,
            start_time:row.startTime,
            end_time:row.endTime,
            rwid:row.id,

           // kszt:row.
          /* 其他数据 */
          }))
          this.$router.push("/user/rwxq/"+row.id);
        },
        tz(url){

          this.$router.push(url);
        },
        //判断用户的密码是否为初始密码
        pduserdefpwda(){


           var userinfos ;
          if(!JSON.parse(localStorage.getItem('user_infos'))){

            return ;
          }
          userinfos = JSON.parse(localStorage.getItem('user_infos'))

          //return ;
          let param = {userName:userinfos.userName};

            mmts(param)
             .then(res => {

               this.loading = false
               if (res.code != 200) {
                } else {

                 if(res.data == false){

                    this.wxts('温馨提示','您的密码为初始机密，请及时修改','/user/upassedit');
                 }

               }
             })
             .catch(err => {

             })


        },
        wxts(title,content,url){

          this.$confirm(content, title, {
                    confirmButtonText: '立即修改',
                    cancelButtonText: '取消',
                    type: 'warning'
                  }).then(() => {
                         this.$router.push(url);
                  }).catch(() => {

                  });

        }
      },



    }
  </script>

<style scoped>
  	body{
  			background-color: #EFEFF4;
  		}



  		.item_list_menu{
  			/* border: solid 1px red; */
  			text-align: center;
  		}
  		.dibumenu{
  			width: 100%;
  			text-align: center;
  			padding-top: 3px;
  		}
  		.dibumenu img{
  			width: 24px;
  			height: 24px;
  		}
  		.xmtitle{
  			text-align: center;
  			font-size: 12px;
  			color: #666666;
  		}
  		.xmtitle_active{
  			color: #00DDA3;
  		}
      .headbt{
        height: 45px;
        width: 100%;
        line-height: 45px;
        background-color: #00DDA3;
      }
      .shouye_active{
        color: #00DDA3;
        border-bottom: solid 2px #00DDA3;
      }
      .headcd{
      			height: 45px;
      			line-height: 45px;
      			width: 100%;
      			background-color: white;
      			text-align: center;
      			display: flex;
            font-size: 18px;
      		}
      		.xz{
      			width: 100%;
      		}
    .rwgl{
      width: 100%;
      height: auto;
      /* padding-top: 10px;
      padding-bottom: 10px;
      border: solid 1px red; */
      margin-top: 15px;
    }
    .border{
    	border-bottom: 1px #3CB9F3 solid;
    	color:#3CB9F3 !important;
    }
    .order_list{
    	width: 100%;
    	height: auto;

    	background-color: white;
    	margin-top: 12px;
    }
    .order_list_u{
    	margin-top: 5px;

    }



    .userliebiao{
    	display: flex;
    	font-size: 14px;
    	height: auto;
    	padding-top: 5px;
    	padding-bottom: 5px;
    	background-color: white;

    }
    .userinfo{
    	text-align: right;
    }
    .form-control{
    	 border: none !important;
    	font-size: 14px;
    	height: 3rem;

    }
    .form-control:focus {
        outline: none;
        border-color: #ccc;
        border: none;
        -webkit-box-shadow: none;
        box-shadow: none;
    }

    .xingxing{
    	color:red;
    }
    .list-group{
    	--bs-list-group-border-radius:0 0 0 0 !important;
    }



    .list-group{
    	--bs-list-group-border-radius:0 0 0 0 !important;
    }

    .list-group-item{
    	border-radius: 0 0 0 0 ;
    	border: none !important;
    	padding:  0 0 0 0 !important;

    	height: 3rem;
    	line-height:3rem;
    	font-size: 14px;
    	color: #666666;
    	border-bottom: solid  1px #E6EAEC !important;
    }
    .list-group-item:first-child{
    	border-top-left-radius: 0;
    	border-top-right-radius: 0;

    }
    .item_list_menu{
    	/* border: solid 1px red; */
    	text-align: center;
    }

    .userinfo{
    	text-align: right;
    }
    .dibuxian{
    	width: 100%;
    	height: 90px;
    }
    .yjt img{
    	width: 24px;
    	height: 24px;
    }
    .zjt img{
    	width: 22px;
    	height: 22px;
      float: left;
      margin-top: 9px;

    }
    .bfwrxx_left{
    	text-align: left !important;
    	font-size: 18px  !important;
    	line-height: 40px !important;

    }
    .qrbc{
    	width:40%;
    	height: 30px;
    	/* margin: 0 auto; */
    	text-align: center;
    	line-height: 30px;
    	color: white;
    	border-radius: 5px 5px 5px 5px;
    	background-color: #00DDA3;
    	margin-top: 15px;
    	margin-bottom: 15px;
      float: right;
    }
    .uinfo{
    	width: 94%;
      margin:  0 auto;
    	height: auto;
    	padding-top: 5px;
    	padding-bottom: 5px;
    	background-color: white;
      box-shadow: 5px 5px 5px 5px #ccc;
      border-radius: 5px 5px 5px 5px;
    }
    .uinfo_1{
    	width: 90%;
    	height: auto;
    	margin: 0 auto;

    }
    .bkx{
      width: 100%;
      height: 80px;
    }
    .list-group{
    	--bs-list-group-border-radius:0 0 0 0 !important;
    }

    .list-group-item{
    	border-radius: 0 0 0 0 ;
    	border: none !important;
    	padding:  0 0 0 0 !important;

    	height: 3rem;
    	line-height:3rem;
    	font-size: 14px;
    	color: #666666;
    	border-bottom: solid  1px #E6EAEC !important;
    }
    .list-group-item:first-child{
    	border-top-left-radius: 0;
    	border-top-right-radius: 0;

    }

    .userliebiao{
    	display: flex;
    	font-size: 14px;
    	height: auto;
    	padding-top: 5px;
    	padding-bottom: 5px;
    	background-color: white;

    }
    .userinfo{
    	text-align: right;
    }
    .form-control{
    	 border: none !important;
    	font-size: 14px;
    	height: 3rem;

    }
    .form-control:focus {
        outline: none;
        border-color: #ccc;
        border: none;
        -webkit-box-shadow: none;
        box-shadow: none;
    }

    .xingxing{
    	color:red;
    }
.rwmc{

  font-weight: bold;
  color: balck;
}
.leftsj{

  text-align: left;
}
.rightsj{

  text-align: right;
}

.ygq {
  position: absolute;
  width: 90%; /* 或者你需要的宽度 */
  height: 60px; /* 或者你需要的高度 */
  border: solid 1px red;

  z-index: 999;
  /* 其他样式 */
}
.ygqa img{
  width: 64px;
  height: 45px;
  float: right;
}
.jxz{
  color: #00DDA3;
  font-weight: bold;
}
.rwlast{
  border-bottom: none !important;
  text-align: right;height: 50px;
}
 .fixed-right {
   position: fixed;
   top: 400px; /* 根据需要调整顶部距离，例如：0px 表示贴紧顶部 */
   right: 0;
   width: 50px; /* 根据需要设置宽度 */
   height: 50px; /* 根据需要设置高度 */

   color: #666666; /* 文字颜色 */
   /* padding: 10px; */ /* 内边距 */
   margin-right: 3%;
   text-align: center;
   font-size: 11px;
   background-color: rbg(108,108,108,0.5);
   border-radius: 5px 5px 5px 5px;
   box-sizing: border-box; /* 防止内边距影响实际宽度和高度 */
 }
 .fixed-right img{
   width: 40px;
   height: 40px;
  /* margin-right: 15px; */
 }
.jiacu{
  font-weight: bold;
}
</style>




// WEBPACK FOOTER //
// src/views/base/index.vue